import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import {
  BokkzClient,
  ClientEntity,
  UitstelGegevens,
  UitstelGegevensBelastingmiddel,
  UitstelGegevensSoortUitstelVerzoek
} from "../services/api.bokkz.services";
import {ToastService} from "@snelstart/ui-toast";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { CommonModule } from '@angular/common';
import {BokkzAlgDataService} from "../services/bokkz-alg-data-service";

@Component({
  selector: 'snelstart-venture-fiscaal-domain-logic-uitstel',
  templateUrl: './uitstel.component.html',
  imports: [
    CommonModule,
    SharedUiButtonModule,
    SharedUiDialogModule,
    SharedUiFormControlsModule
  ],
  styleUrl: './uitstel.component.css'
})
export class UitstelComponent implements OnInit {

  @Input() public dialogVisible = false;
  @Input() public client = {} as ClientEntity;
  @Output() public dialogVisibleChange = new EventEmitter<boolean>();

  protected readonly UitstelGegevensSoortUitstelVerzoek = UitstelGegevensSoortUitstelVerzoek;
  protected readonly UitstelGegevensBelastingmiddel = UitstelGegevensBelastingmiddel;
  public uitstelGegevens = {} as UitstelGegevens;
  public uitstelFg = {} as FormGroup;
  public year = {} as number;
  public error: any;

  public optionsSoortUitstel: SelectFormControlItem<string>[] = [
    {label: "Aanvullend uitstel", value: UitstelGegevensSoortUitstelVerzoek.AANVULLEND_UITSTEL},
    {label: "Afmelden uitstelregeling", value: UitstelGegevensSoortUitstelVerzoek.AFMELDEN_UITSTEL}
  ];

  public optionsMiddelUitstel: SelectFormControlItem<string>[] = [
    {label: "Inkomstenbelasting", value: UitstelGegevensBelastingmiddel.INKOMSTENBELASTING},
    {label: "Vennootschapsbelasting", value: UitstelGegevensBelastingmiddel.VENNOOTSCHAPSBELASTING},
  ];

  constructor(
    private toastService: ToastService,
    private algDataService: BokkzAlgDataService,
    private bokkzClient: BokkzClient,
    public fb: FormBuilder,
  ) {
    this.uitstelFg = this.fb.group<UitstelGegevens>({
      fiscaalNummer: this.client.taxId || null as unknown as string,
      voorlettersBelastingplichtige: null as unknown as string,
      tussenVoegselBelastingplichtige: null as unknown as string,
      achternaamBelastingplichtige: null as unknown as string,
      soortUitstelVerzoek: null as unknown as UitstelGegevensSoortUitstelVerzoek,
      motivatieBijzonderUitstel: null as unknown as string,
      belastingmiddel: null as unknown as UitstelGegevensBelastingmiddel,
      boekjaarStart: null as unknown as Date,
      boekjaarEind: null as unknown as Date,
    })
  }

  ngOnInit(): void {
    this.algDataService.selectedYear.subscribe(value => {
      this.year = value;
    })
    this.uitstelFg.patchValue(this.uitstelGegevens)
  }

  public saveForm() {
    if (this.uitstelFg.get('belastingmiddel')?.value === UitstelGegevensBelastingmiddel.INKOMSTENBELASTING) {
      this.uitstelFg.patchValue({boekjaarStart: new Date("01-01-" + this.year)})
      this.uitstelFg.patchValue({boekjaarEind: new Date("12-31-" + this.year)})
    }
    this.uitstelGegevens = {
      fiscaalNummer: this.uitstelFg.value.fiscaalNummer,
      voorlettersBelastingplichtige: this.uitstelFg.value.voorlettersBelastingplichtige,
      tussenVoegselBelastingplichtige: this.uitstelFg.value.tussenVoegselBelastingplichtige,
      achternaamBelastingplichtige: this.uitstelFg.value.achternaamBelastingplichtige,
      soortUitstelVerzoek: this.uitstelFg.value.soortUitstelVerzoek,
      motivatieBijzonderUitstel: this.uitstelFg.value.motivatieBijzonderUitstel,
      belastingmiddel: this.uitstelFg.value.belastingmiddel,
      boekjaarStart: this.uitstelFg.value.boekjaarStart,
      boekjaarEind: this.uitstelFg.value.boekjaarEind,
    }
  }

  public postUitstelGegevens() {
    this.bokkzClient.postPostponement(this.client.id!.toString(), true, this.uitstelGegevens).subscribe({
      next: () => {
        this.uitstelFg.patchValue(this.uitstelGegevens);
      },
      error: (err) => {
        this.error = err;
      },
      complete: () => {
        this.dialogVisibleChange.emit(false)
        this.toastService.showSuccessMessage("Wijziging succesvol opgeslagen.")
      }
    })
  }
}
